import { useUserRoles, useUserDefaultRole } from '@nhost/react'

export default function useSuperAdmin(): boolean {
  const roles = useUserRoles()
  const defaultRole = useUserDefaultRole()
  return roles.includes('admin') && defaultRole === 'admin'
}
